var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"mt-5"},[(_vm.columnInstituciones.length  == 0)?_c('div',[_c('p',[_vm._v("No hay datos que mostrar")])]):_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"bar","height":"500","options":_vm.columnInstituciones.chartOptions,"series":_vm.columnInstituciones.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }